export interface ScanStatsDTO {
  scanCustomerCount?: number;
  scanVehicleCount?: number;
  scanQueueCount?: number;
}
